<template>
    <div>
        <el-card>
            <el-form inline ref="form">
                <!-- <el-form-item label="设备号">
                    <el-input v-model="searchData.deviceId" placeholder="输入设备号"></el-input>
                </el-form-item> -->
                <!-- <el-form-item label="工号">
            <el-input v-model="searchData.cardNumber" placeholder="输入巡检员工号"></el-input>
          </el-form-item>
          <el-form-item label="所属停车场">
            <el-select v-model="searchData.parkId" placeholder="请选择" filterable>
              <el-option v-for="item in $store.state.park.list" :key="item.id" :label="item.parkingName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker v-model="searchData.datetimeRange" type="daterange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item> -->
                <el-form-item>
                    <el-button type="primary" @click="$refs.table.reloadData()">查 询</el-button>
                    <el-button @click="Object.assign($data.searchData, $options.data().searchData)">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <cui-table :url='$api.queryLockCarList' :data='searchData' ref="table">
            <el-table-column prop="plate" label="车牌" min-width="150"></el-table-column>
            <el-table-column prop="enterTime" label="入场时间" min-width="150"></el-table-column>
            <el-table-column prop="parkingName" label="车场" min-width="150"></el-table-column>
            <el-table-column prop="seatNum" label="车位号" min-width="150"></el-table-column>
            <el-table-column prop="totalArrearsAmount" label="欠费金额" min-width="150"></el-table-column>
            <el-table-column prop="totalArrearsCount" label="欠费次数" min-width="150"></el-table-column>
            <el-table-column label="当前是否锁车" min-width="150">
                <template slot-scope="scope">
                    <el-tag type="info" v-if="scope.row.currentLockStatus == 0">锁车中</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="lockSuccessCount" label="锁车成功次" min-width="150"></el-table-column>
            <el-table-column prop="lockFailureCount" label="锁车催收失败次" min-width="150"></el-table-column>
            
            <!-- <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" @click="$router.push(`/ops/detail?cardNumber=${scope.row.cardNumber}&userId=${scope.row.userId}&roleType=${scope.row.roleType}`)">详情</el-button>
          </template>
        </el-table-column> -->
        </cui-table>

        <cui-dialog ref="dialog" :event="dialogEvent" v-model="dialogData" @sync="(value) => { dialogData = value; }">
            <template v-if="dialogType == 'task'">
                <el-tabs v-model="dialogData.taskType" type="card">
                    <el-tab-pane label="待巡检" name="1">用户管理</el-tab-pane>
                    <el-tab-pane label="巡检中" name="2">配置管理</el-tab-pane>
                    <el-tab-pane label="已巡检" name="3">角色管理</el-tab-pane>
                </el-tabs>
                <cui-table :url='$api.selectLockList' :data='dialogData' ref="table">
                    <el-table-column fixed prop="cardNumber" label="工号" width="150"></el-table-column>
                    <el-table-column prop="userName" label="姓名" width="150"></el-table-column>
                    <el-table-column prop="parkingName" label="所属停车场" width="150"></el-table-column>
                </cui-table>
            </template>
            <template v-if="dialogType == 'complaint'"></template>
            <template #footer>
                <el-button @click="$refs.dialog.dialogClose()">关 闭</el-button>
            </template>
        </cui-dialog>
    </div>
</template>
  
<script>
export default {
    name: "opsLock",
    title: "锁车记录",
    data() {
        return {
            searchData: {
                currentPage: 1,
                pageSize: 10,
                count: 0,
                roleType: "3",
                nickName: "",
                cardNumber: "",
                parkId: "",
                datetimeRange: [],
                startTime: "",
                endTime: "",
            },
            dialogData: {},
            dialogType: "",
            dialogEvent: {
                task: {
                    title: "巡检任务",
                    width: "800px",
                },
                complaint: {
                    title: "投诉记录",
                    width: "800px",
                },
            },
        };
    },
    watch: {
        "searchData.datetimeRange": function (value) {
            if (value && value.length == 2) {
                this.searchData.startTime = value[0];
                this.searchData.endTime = value[1];
            } else {
                this.searchData.startTime = "";
                this.searchData.endTime = "";
            }
        },
    },
    created() {
        // this.$store.state.park.haveData || this.globalLoadParkList();
    },
    methods: {
        showDialog(id, type) {
            this.dialogData.id = id;
            this.dialogType = type;
            this.$refs.dialog.showDialog(type);
        },
    },
};
</script>
  
<style></style>